module.exports = __webpack_public_path__ + "static/media/plane-departure.31e97713.svg";